import { TitlesTyp } from "../../../../../../components/Typography/Typography";
import { FontWeightEnum } from "../../../../../../types/AppTypes";
import {
  COLLABORATOR_COMMENT_LABEL,
  COLLABORATOR_FEEDBACK_LABEL,
  DESCRIPTION_LABEL,
  STARS_LABEL,
} from "../../../../../../constants/Dictionary";
import { StyledManagementHeader } from "../../../../Management.styled";
import { FeedbacksEvaluationConfigItem } from "../../../../../../types/api/configurations.type";
import {
  ManagementTable,
  ManagementTableHeader,
} from "../../../../Components/Table/ManagementTable";
import { FieldValues } from "react-hook-form";
import { compareDataGeneric } from "../../../../../../utils/comparing.utils";
import {
  useManageFeedbacks,
  useUpdateManageFeedbacks,
} from "../../../../../../hooks/management/CmSheet/Feedbacks/useManagementFeedbacks.hooks";

type ManageFeedbacksProps = {
  configYear: number;
};

export const ManageFeedbacks = ({ configYear }: ManageFeedbacksProps) => {
  const { data, isFetching } = useManageFeedbacks(configYear);
  const { mutate: updateManageFeedbacks, isPending: isUpdatingFeedbacks } =
    useUpdateManageFeedbacks();

  const feedbacksColumns: ManagementTableHeader[] = [
    {
      key: "description",
      label: DESCRIPTION_LABEL,
      width: 100,
      type: "text",
    },
  ];

  const onSave = async (formData: FieldValues) => {
    const compareData = (formData.items as FeedbacksEvaluationConfigItem[]).map(
      (item, index) => ({
        ...item,
        stars: index + 1,
      }),
    );
    const result = compareDataGeneric<FeedbacksEvaluationConfigItem>(
      data!,
      compareData,
    );
    updateManageFeedbacks(result);
  };

  return (
    <>
      <StyledManagementHeader>
        <TitlesTyp variant="2" fontWeight={FontWeightEnum.SEMIBOLD}>
          {COLLABORATOR_COMMENT_LABEL}
        </TitlesTyp>
      </StyledManagementHeader>
      <ManagementTable<FeedbacksEvaluationConfigItem>
        data={data ?? []}
        keyItem={"description"}
        headers={feedbacksColumns}
        itemLabel={COLLABORATOR_FEEDBACK_LABEL}
        draggableRows
        onSave={onSave}
        loading={isFetching || isUpdatingFeedbacks}
        orderColumnName={STARS_LABEL}
      />
    </>
  );
};
